import React from 'react'

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton,
    TitleContainer
} from "../CandidateView.styles";

interface NoShowConfirmationProps {
    onConfirm: () => Promise<void>
    onCancel: () => void
}

const NoShowConfirmation = ({
    onConfirm,
    onCancel,
}: NoShowConfirmationProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>Confirm No-Show?</PopupTitle></TitleContainer>
            <PopupDescription>
                Only mark as a no-show if the candidate missed their interview without contacting you first.
            </PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onCancel}
                    color="primary"
                    size="large"
                    id="cancel-button"
                    className="bigButtonInNewStyle"
                >
                    Cancel
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="confirm-button"
                    className="bigButtonInNewStyle"
                >
                    Confirm
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    )
}

export default NoShowConfirmation;
